import React, { useMemo } from 'react';
import { Box } from '@mui/material';
import FormField from '../../FormField';
import { groupNumericFields } from '../utils/groupNumericFields';
import { FormSectionFieldsProps } from './FormSection.types';

const FIELD_STYLES = { minWidth: 0 };

/** Preserve the mobile column while restoring compact numeric pairs on desktop. */
export const FormSectionFields = React.memo(function FormSectionFields({
  fields,
  values,
  onFieldChange,
  getFieldError,
  compact,
  isMobile,
  fieldSpacing,
  preloadedOptions,
  showCopyButton,
}: FormSectionFieldsProps) {
  const rows = useMemo(
    () =>
      groupNumericFields(fields).map((row) => ({
        ...row,
        styles: {
          display: 'grid',
          gridTemplateColumns: {
            xs: 'minmax(0, 1fr)',
            md: row.fields.length === 2 ? 'repeat(2, minmax(0, 1fr))' : 'minmax(0, 1fr)',
          },
          columnGap: 2,
          rowGap: fieldSpacing,
          mb: fieldSpacing,
          maxWidth: row.isNumeric && row.fields.length === 1 ? { xs: '100%', md: '300px' } : '100%',
        },
      })),
    [fields, fieldSpacing],
  );

  return (
    <Box>
      {rows.map((row) => (
        <Box key={row.fields[0].name} sx={row.styles}>
          {row.fields.map((field) => (
            <Box key={field.name} sx={FIELD_STYLES}>
              <FormField
                field={field}
                value={values[field.name]}
                onChange={onFieldChange}
                error={getFieldError(field.name)}
                compact={row.isNumeric || compact || isMobile}
                isMobile={isMobile}
                preloadedOptions={preloadedOptions?.[field.name]}
                showCopyButton={showCopyButton}
              />
            </Box>
          ))}
        </Box>
      ))}
    </Box>
  );
});
